export const sendEvent = (eventName: string) => {
  window.monetateQ = window.monetateQ || []
  window.monetateQ.push(['trackEvent', [eventName]])
}
